function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M16.667 1.667c.92 0 1.666.746 1.666 1.666v15L15 15H3.333c-.92 0-1.666-.746-1.666-1.667v-10c0-.92.746-1.666 1.666-1.666zm0 1.666H3.333v10h12.359l.483.492.492.483V3.333zm-5 5.834v1.666H5.833V9.167h5.834zm2.5-3.334V7.5H5.833V5.833h8.334z"
});

function SvgFeedbackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "#4EA15A"
  }, props), _ref);
}

export default SvgFeedbackIcon;